(function() {
  function openTab(e) {
    e.currentTarget.closest('.tabs').querySelectorAll('a').forEach(function(item) {
      item.classList.remove('active');
    });
    
    e.currentTarget.classList.add('active');
    
    
    var tab_content_id = e.currentTarget.getAttribute('href').replace('#', '');
    document.querySelectorAll('.tabs-content li').forEach(function(item) {
      item.classList.remove('active');
    });
    
    document.querySelector('#' + tab_content_id).classList.add('active');
  }
  
  function initTabs() {
    document.querySelectorAll('.tabs a').forEach(function(item) {
      item.addEventListener('click', function(e) {
        e.preventDefault();
        openTab(e);
      });
    });
  }

  function getCart() { 
    return fetch('/cart.js').then((res) => res.json());
  }

  function removeCartItems(items) {
    return new Promise((resolve, reject) => { 
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates: items })
      })
        .then(res => res.json())
        .then(resolve)
        .catch(reject);
    });
  }
  
  function CartRemoveBundleItem() {
    document.querySelectorAll('[data-bundle-remove]').forEach(($btn) => { 
      $btn.addEventListener('click', (e) => { 
        e.preventDefault();
        let bundle_id = $btn.dataset.bundleid;
        getCart()
          .then((cart) => { 
            let bundle_items = cart.items.filter(item => item.properties._bundle_id == bundle_id);
            let remove_items_obj = {};
            bundle_items.forEach((item) => {
              remove_items_obj[item.key] = 0;
            });

            removeCartItems(remove_items_obj)
              .then(() => {
                window.location.href = '/cart';
              })
              .catch(console.error);
          });
      });
    });
  }
  
  document.addEventListener('DOMContentLoaded', function() {
    initTabs();
    CartRemoveBundleItem();
  });
})();